export default __webpack_public_path__ + "static/bncff-web-site-6-46df6ad28e6c56bf0aee099a10ce6229.jpg";